'use client';

import useImage from '@components/img/img.hook';
import type { SanityImageSource } from '@sanity/image-url/lib/types/types';
import Image from 'next/image';
import type { ReactElement } from 'react';
import React from 'react';
import type PropsWithClassname from 'types/props-with-classname';

export type ImageEffect = 'box-right' | 'color' | 'outline-right' | 'outline';

interface Props extends PropsWithClassname {
  readonly imageSource: SanityImageSource;
  readonly alt: string;
  readonly fill?: boolean;
  readonly contain?: boolean | undefined;
  readonly priority?: boolean | undefined;
  readonly imageStyle?: 'arch' | undefined;
  readonly effect?: ImageEffect | undefined;
  readonly sizes?: string | undefined;
}

// TODO: This is a crap design, should not use Sanity types directly and should be used instead of all next/image instances
function Img({
  imageSource,
  imageStyle,
  alt,
  contain = false,
  className,
  fill = false,
  priority = false,
  effect,
  sizes,
}: Props): ReactElement | null {
  const { imageProps, imageClass, wrapperClass } = useImage({
    imageSource,
    imageStyle,
    contain,
    className,
    fill,
    effect,
  });

  return imageProps !== null ? (
    <div
      className={wrapperClass}
      style={{ position: fill || contain ? undefined : 'relative' }}
    >
      <Image
        alt={alt}
        className={imageClass}
        fill={fill || contain}
        {...(fill || contain
          ? {
              src: imageProps.src,
              loader: imageProps.loader,
            }
          : { ...imageProps, objectPosition: undefined })}
        blurDataURL={imageProps.blurData}
        placeholder={typeof imageProps.blurData === 'string' ? 'blur' : 'empty'}
        priority={priority}
        sizes={sizes}
        style={{
          objectPosition: imageProps.objectPosition,
        }}
      />
    </div>
  ) : null;
}

export default Img;
